<template>
  <div class="action-btn" :class="setupBtnClass">
    <i v-if="icon" :class="setupIconClass"></i>
    <p :class="setupTextClass">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'button-positive',

  props: {
    positive: {
      type: Boolean,
      required: true,
      default: true,
    },
    icon: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'md',
    },
  },

  computed: {
    setupBtnClass() {
      let finalString = `${this.size} `
      if (this.positive) {
        finalString += `btn positive bg-${this.color}`
      } else {
        finalString += `btn negative bg-white border-${this.color}`
      }
      return finalString
    },

    setupTextClass() {
      if (this.positive) {
        return 'text-white'
      }
      return `text-${this.color}`
    },

    setupIconClass() {
      let finalString = ''
      if (this.positive) {
        finalString += `text-white ${this.icon}`
      } else {
        finalString += `text-${this.color} ${this.icon}`
      }
      if (!this.text) {
        finalString += ' m-0'
      }
      return finalString
    },
  },
}
</script>

<style scoped></style>
